var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// <define:import.meta.env>
var define_import_meta_env_default = { MODE: "production", DEV: false, PROD: true, BASE_URL: "./", VITE_MM_API_BASE_URL: "/apps/app-proxy", VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_DE_DEV: "e1b1a18b200d8096f9a767852b20320b", VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_DE_TEST: "8ac0ecb3029cffda27d06dd0ad3ade63", VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_DE_PROD: "148071bd7ceb7b42051cf185ef49884d", VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_CH_TEST: "1c140f5fde2e4f0bea57dc7cc7d885fc", VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_CH_PROD: "80c6148cbe40627d46299255c603e889", VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_PATRICK_DEV: "6b92d1eb9cdbacb8286790a431fed193", VITE_SHOPIFY_STOREFRONT_API_VERSION: "2025-04", VITE_UPLOADCARE_PUBLIC_KEY_DEV: "7b716bf926dff9462574", VITE_UPLOADCARE_PUBLIC_KEY_TEST: "7b716bf926dff9462574", VITE_UPLOADCARE_PUBLIC_KEY_PROD: "e03be71aaf0aff3e6680" };

// _src/lib/config.ts
var getEnvironmentConfig = () => {
  const isDevelopment = false;
  const isProduction = true;
  const storefrontDomain = window.Shopify?.shop;
  let storefrontAccessToken = "";
  let uploadcarePublicKey = "";
  switch (storefrontDomain) {
    case "mymuesli-dev.myshopify.com":
      storefrontAccessToken = define_import_meta_env_default.VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_DE_DEV;
      uploadcarePublicKey = define_import_meta_env_default.VITE_UPLOADCARE_PUBLIC_KEY_DEV;
      break;
    case "mymuesli-test.myshopify.com":
      storefrontAccessToken = define_import_meta_env_default.VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_DE_TEST;
      uploadcarePublicKey = define_import_meta_env_default.VITE_UPLOADCARE_PUBLIC_KEY_TEST;
      break;
    case "mymuesli-prod.myshopify.com":
      storefrontAccessToken = define_import_meta_env_default.VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_DE_PROD;
      uploadcarePublicKey = define_import_meta_env_default.VITE_UPLOADCARE_PUBLIC_KEY_PROD;
      break;
    case "mymuesli-ch-test.myshopify.com":
      storefrontAccessToken = define_import_meta_env_default.VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_CH_TEST;
      uploadcarePublicKey = define_import_meta_env_default.VITE_UPLOADCARE_PUBLIC_KEY_TEST;
      break;
    case "mymuesli-ch-prod.myshopify.com":
      storefrontAccessToken = define_import_meta_env_default.VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_CH_PROD;
      uploadcarePublicKey = define_import_meta_env_default.VITE_UPLOADCARE_PUBLIC_KEY_PROD;
      break;
    case "mymuesli-patrick-dev.myshopify.com":
      storefrontAccessToken = define_import_meta_env_default.VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN_PATRICK_DEV;
      uploadcarePublicKey = define_import_meta_env_default.VITE_UPLOADCARE_PUBLIC_KEY_DEV;
      break;
  }
  return {
    isDevelopment,
    isProduction,
    apiBaseUrl: define_import_meta_env_default.VITE_MM_API_BASE_URL,
    storefrontDomain,
    storefrontAccessToken,
    storefrontApiVersion: define_import_meta_env_default.VITE_SHOPIFY_STOREFRONT_API_VERSION,
    uploadcarePublicKey
  };
};
var config = getEnvironmentConfig();
var config_default = config;

// _src/lib/apiClient.ts
var ApiClient = class {
  /**
   * Makes a request to the MyMuesli API with consistent error handling.
   *
   * @param endpoint - The endpoint to fetch data from
   * @param data - The data to send to the API
   * @returns Promise with standardized response format
   */
  static async fetchMyMuesliApi(endpoint, data) {
    const baseUrl = config_default.apiBaseUrl;
    try {
      const res = await fetch(`${baseUrl}/${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });
      const result = await res.json();
      if (res.status !== 200) {
        if (config_default.isDevelopment) {
          console.error(`[MyMuesli API] Error fetching data`, result);
        }
      }
      return {
        result: res.status === 200 ? result : null,
        status: res.status,
        error: res.status !== 200 ? result : null
      };
    } catch (error) {
      if (config_default.isDevelopment) {
        console.error(`[MyMuesli API] Error fetching data`, error);
      }
      return {
        result: null,
        status: 500,
        error
      };
    }
  }
  /**
   * Fetches mix configuration from the MyMuesli API.
   * Standardized method for retrieving mix configuration data.
   *
   * @param mixUid - The unique identifier of the mix
   * @returns Promise with mix configuration data
   */
  static async fetchMixConfiguration(mixUid) {
    try {
      const response = await this.fetchMyMuesliApi("custommixconfiguration", {
        mix_uid: mixUid
      });
      if (response.status === 200) {
        return response.result.mix_configuration;
      } else {
        console.error(response.error);
        return null;
      }
    } catch (error) {
      console.error("Error fetching mix configuration:", error);
      return null;
    }
  }
  /**
   * Fetches ingredients declaration from the MyMuesli API.
   *
   * @param ingredients - Array of ingredient data [sku, weight]
   * @param language - Language code
   * @param country - Country code
   * @returns Promise with ingredients declaration data
   */
  static async fetchIngredientsDeclaration(ingredients, language, country) {
    try {
      const response = await this.fetchMyMuesliApi("listofingredients", {
        ingredients,
        localeIdentifier: `${language.toLowerCase() || "de"}_${country.toUpperCase() || "DE"}`
      });
      if (response.error) {
        throw response.error;
      }
      return response.result;
    } catch (error) {
      console.error("Error fetching ingredients declaration:", error);
      return null;
    }
  }
  /**
   * Fetches nutrition data from the MyMuesli API.
   *
   * @param ingredients - Array of ingredient data [sku, weight]
   * @param language - Language code
   * @param country - Country code
   * @returns Promise with nutrition data
   */
  static async fetchNutritionData(ingredients, language, country) {
    try {
      const response = await this.fetchMyMuesliApi("nutritions", {
        ingredients,
        perGram: "100",
        localeIdentifier: `${language.toLowerCase() || "de"}_${country.toUpperCase() || "DE"}`
      });
      if (response.error) {
        throw response.error;
      }
      return response.result;
    } catch (error) {
      console.error("Error fetching nutrition data:", error);
      return null;
    }
  }
  /**
   * Fetches flavor profile data from the MyMuesli API.
   *
   * @param ingredients - Array of ingredient data [sku, weight]
   * @returns Promise with flavor profile data
   */
  static async fetchFlavorProfile(ingredients) {
    try {
      const response = await this.fetchMyMuesliApi("flavor", {
        ingredients
      });
      if (response.error) {
        throw response.error;
      }
      return response.result;
    } catch (error) {
      console.error("Error fetching flavor profile:", error);
      return null;
    }
  }
  /**
   * Fetches additional hints data from the MyMuesli API.
   *
   * @param ingredients - Array of ingredient data [sku, weight]
   * @param language - Language code
   * @param country - Country code
   * @returns Promise with additional hints data
   */
  static async fetchAdditionalHints(ingredients, language, country) {
    try {
      const response = await this.fetchMyMuesliApi("additionalhints", {
        ingredients,
        localeIdentifier: `${language.toLowerCase() || "de"}_${country.toUpperCase() || "DE"}`
      });
      if (response.error) {
        throw response.error;
      }
      return response.result.additionalHints;
    } catch (error) {
      console.error("Error fetching additional hints:", error);
      return null;
    }
  }
  /**
   * Fetches all external API data in parallel.
   *
   * @param ingredients - Array of ingredient data [sku, weight]
   * @param language - Language code
   * @param country - Country code
   * @returns Promise with all external API data
   */
  static async fetchAllExternalApiData(ingredients, language, country) {
    const [ingredientsDeclaration, flavour, nutrition, additionalHints] = await Promise.all([
      this.fetchIngredientsDeclaration(ingredients, language, country),
      this.fetchFlavorProfile(ingredients),
      this.fetchNutritionData(ingredients, language, country),
      this.fetchAdditionalHints(ingredients, language, country)
    ]);
    return {
      ingredientsDeclaration,
      flavour,
      nutrition,
      additionalHints
    };
  }
};

// _src/theme-assets/mymuesli-storage-service.ts
var maxAge = 24 * 60 * 60 * 1e3;
var DEFAULT_CONFIG = {
  prefix_mix: "mymuesli_mix_",
  prefix_design: "mymuesli_design_",
  key_blacklist: "mymuesli_blacklist",
  customer_logged_in: false,
  customer_id: null,
  customer_metafields_mixes: [],
  customer_metafields_designs: [],
  cutoffTime: Date.now() - maxAge
};
var MyMuesliStorageService = class {
  /**
   * Creates a storage service with optional configuration overrides.
   * @param config - Partial configuration to override defaults
   */
  constructor(config2 = {}) {
    __publicField(this, "config");
    __publicField(this, "storage");
    this.config = { ...DEFAULT_CONFIG, ...config2 };
    this.storage = window.localStorage;
    this.initialize();
  }
  /**
   * Bootstraps synchronization and validations against localStorage and the cart.
   */
  initialize() {
    this.syncUserMixesMetafieldDataWithLocalStorage();
    this.syncUserDesignsMetafieldDataWithLocalStorage();
    this.checkDesignValidity();
    this.checkMixValidity();
    this.checkLineItemsValidity();
    this.checkAuthorization();
  }
  /**
   * Checks if the current user is authorized to access a mix page and exposes
   * decoded configuration globally for the dynamic product page.
   * Only runs on the `/pages/mix` route.
   * @returns {Promise<boolean | undefined>} true if authorized, false if redirected, undefined otherwise
   */
  async checkAuthorization() {
    if (window.location.pathname === "/pages/mix") {
      const searchParams = new URLSearchParams(window.location.search);
      const mixUid = searchParams.get("id");
      const configuration = searchParams.get("configuration");
      let decodedMixConfiguration = null;
      if (mixUid) {
        if (configuration) {
          try {
            decodedMixConfiguration = this.decodeConfigurationPayload(configuration);
          } catch (error) {
            console.error("Error decoding configuration:", error);
          }
        } else {
          const storedMix = await this.findMix(mixUid);
          if (storedMix) {
            decodedMixConfiguration = storedMix.configuration;
          } else {
            const encodedMixConfiguration = await this.getMixConfigurationFromApiByMixUid(mixUid);
            if (encodedMixConfiguration) {
              decodedMixConfiguration = this.decodeConfigurationPayload(encodedMixConfiguration);
            }
          }
        }
        if (decodedMixConfiguration) {
          window.MyMuesli = window.MyMuesli || {};
          window.MyMuesli.dynamicProduct = window.MyMuesli.dynamicProduct || {};
          window.MyMuesli.dynamicProduct.configuration = decodedMixConfiguration;
          window.MyMuesli.dynamicProduct.mixUid = mixUid;
          if (decodedMixConfiguration.customerId === void 0 || decodedMixConfiguration.customerId !== "" && decodedMixConfiguration.customerId === this.config.customer_id) {
            return true;
          }
        }
      }
      if (!window?.Shopify?.designMode) {
        window.location.href = "/404";
      }
      return false;
    }
  }
  /**
   * Fetches an encoded mix configuration string via API by mix UID.
   * @param mix_uid - The mix UID
   * @returns Promise resolving to the encoded configuration string or null
   */
  async getMixConfigurationFromApiByMixUid(mix_uid) {
    try {
      const response = await ApiClient.fetchMyMuesliApi("custommixconfiguration", {
        mix_uid
      });
      if (response.status === 200) {
        return response.result.mix_configuration;
      } else {
        console.error(response.error);
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  /**
   * Sync mix metafield data with localStorage
   */
  syncUserMixesMetafieldDataWithLocalStorage() {
    try {
      const customerMixes = this.config.customer_metafields_mixes || [];
      if (Array.isArray(customerMixes) && customerMixes.length > 0) {
        customerMixes.forEach((mix) => {
          if (mix?.mix_uid) {
            const storageKey = this.getMixStorageKey(mix.mix_uid);
            if (!this.storage.getItem(storageKey)) {
              this.storage.setItem(storageKey, this.serialize(mix));
            }
          }
        });
        console.log(`Loaded ${customerMixes.length} customer mixes into localStorage`);
      }
    } catch (error) {
      console.error("Error loading customer mixes into localStorage:", error);
    }
  }
  /**
   * Sync design metafield data with localStorage
   */
  syncUserDesignsMetafieldDataWithLocalStorage() {
    try {
      const customerDesigns = this.config.customer_metafields_designs || [];
      if (Array.isArray(customerDesigns) && customerDesigns.length > 0) {
        customerDesigns.forEach((design) => {
          if (design?.id) {
            const storageKey = this.getDesignStorageKey(String(design.id));
            if (!this.storage.getItem(storageKey)) {
              this.storage.setItem(storageKey, this.serialize(design));
            }
          }
        });
        console.log(`Loaded ${customerDesigns.length} customer designs into localStorage`);
      }
    } catch (error) {
      console.error("Error loading customer designs into localStorage:", error);
    }
  }
  /**
   * Validates whether an individual design identifier contains a timestamp newer than the cutoff.
   * @param identifier - The design identifier (e.g., "individual-<timestamp>-...")
   * @returns true if the contained timestamp is newer than the configured cutoff time
   */
  isValidTimestampFromIdentifier(identifier) {
    if (!identifier) return false;
    const match = identifier.match(/individual-(\d{10,})-/);
    if (!match) return false;
    const createdTs = this.getTimestampFromIdentifier(identifier);
    if (!createdTs) return false;
    return createdTs > this.config.cutoffTime;
  }
  /**
   * Extracts the numeric timestamp from a design identifier string.
   * @param identifier - The design identifier
   * @returns Parsed timestamp in milliseconds, or null if not present
   */
  getTimestampFromIdentifier(identifier) {
    if (!identifier) return null;
    const match = identifier.match(/individual-(\d{10,})-/);
    return match ? parseInt(match[1], 10) : null;
  }
  /**
   * Removes expired or unauthorized designs from localStorage.
   * - If logged in, designs present in customer metafields are kept
   * - Individual designs older than the cutoff are removed
   * @returns Number of removed design entries
   */
  async checkDesignValidity() {
    try {
      const allDesigns = await this.findAllDesigns();
      let deletedCount = 0;
      for (const design of allDesigns) {
        if (this.config.customer_logged_in) {
          if (design?.id && this.config.customer_metafields_designs.some((d) => d?.id === design.id)) {
            continue;
          }
        }
        if (!this.isValidTimestampFromIdentifier(design && design.identifier)) {
          await this.removeDesign(String(design.id));
          deletedCount++;
        }
      }
      if (deletedCount > 0) {
        console.log(`Cleaned up ${deletedCount} old design entries (older than or equal to 24h)`);
      }
      return deletedCount;
    } catch (error) {
      console.error("Failed to cleanup old designs:", error);
      throw error;
    }
  }
  /**
   * Removes mixes whose referenced individual design no longer exists locally.
   * If logged in, mixes present in customer metafields are kept.
   * @returns Number of removed mix entries
   */
  async checkMixValidity() {
    try {
      const allMixes = await this.findAllMixes();
      let deletedCount = 0;
      for (const mix of allMixes) {
        if (this.config.customer_logged_in) {
          if (mix?.mix_uid && this.config.customer_metafields_mixes?.some((m) => m?.mix_uid === mix.mix_uid)) {
            continue;
          }
        }
        if (mix.configuration?.design?.type !== "individual") {
          continue;
        }
        const storageKey = this.getDesignStorageKey(String(mix.configuration.design.id));
        const designExists = this.storage.getItem(storageKey);
        if (!designExists) {
          await this.removeMix(mix.mix_uid);
          deletedCount++;
        }
      }
      if (deletedCount > 0) {
        console.log(`Cleaned up ${deletedCount} stored mixes with deleted designs`);
      }
      return deletedCount;
    } catch (error) {
      console.error("Failed to cleanup mixes with deleted designs:", error);
      throw error;
    }
  }
  /**
   * Validates cart line items with embedded mix configuration.
   * Removes guest items older than the cutoff or items with invalid configuration format.
   * @returns Object containing invalidItems and removedCount
   */
  async checkLineItemsValidity() {
    try {
      const response = await fetch("/cart.json");
      if (!response.ok) throw new Error(`Failed to fetch cart: ${response.status}`);
      const cartData = await response.json();
      const invalidItems = [];
      let removedCount = 0;
      for (const item of cartData.items) {
        if (item.properties && item.properties._mix_configuration) {
          try {
            const decodedConfig = this.decodeConfigurationPayload(
              String(item.properties._mix_configuration)
            );
            if (decodedConfig && decodedConfig.design && decodedConfig.design.identifier) {
              if (!this.isValidTimestampFromIdentifier(decodedConfig.design.identifier)) {
                invalidItems.push({
                  key: item.key,
                  reason: "Guest item is older than 24 hours",
                  item
                });
              }
            }
          } catch {
            invalidItems.push({
              key: item.key,
              reason: "Invalid configuration format",
              item
            });
          }
        }
      }
      if (invalidItems.length > 0) {
        const keysToRemove = invalidItems.map((it) => it.key);
        const removeResult = await this.removeCartItems(keysToRemove);
        if (removeResult) {
          removedCount = invalidItems.length;
          console.log(`Removed ${removedCount} invalid mix items from cart`);
        }
      }
      return { invalidItems, removedCount };
    } catch (error) {
      console.error("Error checking line items validity:", error);
      throw error;
    }
  }
  /**
   * Decodes a base64url-encoded configuration payload to an object.
   * @param base64url - Base64url-encoded string
   * @returns Decoded configuration payload
   */
  decodeConfigurationPayload(base64url) {
    let base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4 !== 0) base64 += "=";
    const jsonString = this.base64Decode(base64);
    const payload = JSON.parse(jsonString);
    return payload;
  }
  /**
   * Decodes a base64 string without using window.atob, to support base64url conversion.
   * @param input - Base64 string
   * @returns Decoded ASCII string
   */
  base64Decode(input) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let str = "";
    let c1, c2, c3, e1, e2, e3, e4, i = 0;
    input = input.replace(/[^A-Za-z0-9+/=]/g, "");
    while (i < input.length) {
      e1 = chars.indexOf(input.charAt(i++));
      e2 = chars.indexOf(input.charAt(i++));
      e3 = chars.indexOf(input.charAt(i++));
      e4 = chars.indexOf(input.charAt(i++));
      c1 = e1 << 2 | e2 >> 4;
      c2 = (e2 & 15) << 4 | e3 >> 2;
      c3 = (e3 & 3) << 6 | e4;
      str += String.fromCharCode(c1);
      if (e3 !== 64) str += String.fromCharCode(c2);
      if (e4 !== 64) str += String.fromCharCode(c3);
    }
    return str;
  }
  /**
   * Builds a storage key for a mix.
   * @param id - Mix UID
   * @returns Namespaced localStorage key
   */
  getMixStorageKey(id) {
    return `${this.config.prefix_mix}${id}`;
  }
  /**
   * Builds a storage key for a design.
   * @param id - Design ID or identifier
   * @returns Namespaced localStorage key
   */
  getDesignStorageKey(id) {
    return `${this.config.prefix_design}${id}`;
  }
  /**
   * Lists all localStorage keys with the given prefix.
   * @param prefix - Key prefix
   * @returns Array of matching keys
   */
  getAllStorageKeysFor(prefix) {
    const keys = [];
    for (let i = 0; i < this.storage.length; i++) {
      const key = this.storage.key(i);
      if (key && key.startsWith(prefix)) keys.push(key);
    }
    return keys;
  }
  /**
   * @returns All keys for stored mixes
   */
  getAllMixStorageKeys() {
    return this.getAllStorageKeysFor(this.config.prefix_mix);
  }
  /**
   * @returns All keys for stored designs
   */
  getAllDesignStorageKeys() {
    return this.getAllStorageKeysFor(this.config.prefix_design);
  }
  /**
   * Serializes data to JSON for storage.
   */
  serialize(data) {
    return JSON.stringify(data);
  }
  /**
   * Deserializes JSON string to typed data.
   */
  deserialize(data) {
    return JSON.parse(data);
  }
  /**
   * Creates a new mix entry; fails if the mix already exists.
   * @param storageData - Mix to persist
   * @returns The stored mix
   */
  async create(storageData) {
    const mixUid = storageData.mix_uid;
    if (!mixUid) throw new Error("Mix UID is required for storage");
    const storageKey = this.getMixStorageKey(mixUid);
    if (this.storage.getItem(storageKey)) {
      throw new Error(`Mix with ID "${mixUid}" already exists`);
    }
    try {
      this.storage.setItem(storageKey, this.serialize(storageData));
      return storageData;
    } catch (error) {
      console.error("Failed to create mix:", error);
      throw error;
    }
  }
  /**
   * Removes cart line items by key via Shopify cart API.
   * @param keys - Cart line item keys to remove
   * @returns API response JSON or false on failure
   */
  async removeCartItems(keys) {
    const updates = {};
    for (const key of keys) updates[key] = 0;
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error(`Failed to remove cart item: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Error removing cart item:", error);
      return false;
    }
  }
  /**
   * Clears all stored mixes and designs from localStorage.
   */
  cleanup() {
    const allMixes = this.getAllMixStorageKeys();
    const allDesigns = this.getAllDesignStorageKeys();
    const allKeys = [...allMixes, ...allDesigns];
    allKeys.forEach((key) => this.storage.removeItem(key));
  }
  /**
   * Find a design by its ID or identifier
   * @param id - The design ID or identifier
   * @returns Promise that resolves to the design or null if not found
   */
  async findDesign(id) {
    try {
      const storageKey = this.getDesignStorageKey(id);
      const data = this.storage.getItem(storageKey);
      if (!data) {
        return null;
      }
      return this.deserialize(data);
    } catch (error) {
      console.error("Failed to find design:", error);
      throw error;
    }
  }
  /**
   * Find a design by its identifier
   * @param identifier - The design identifier
   * @returns Promise that resolves to the design or null if not found
   */
  async findDesignByIdentifier(identifier) {
    const allDesigns = await this.findAllDesigns();
    return allDesigns.find((design) => design.identifier === identifier) || null;
  }
  /**
   * Find all designs in localStorage
   * @returns Promise that resolves to an array of designs
   */
  async findAllDesigns() {
    try {
      const storageKeys = this.getAllDesignStorageKeys();
      const designs = [];
      for (const key of storageKeys) {
        try {
          const data = this.storage.getItem(key);
          if (data) designs.push(this.deserialize(data));
        } catch (error) {
          console.error("Failed to find design:", error);
        }
      }
      return designs;
    } catch (error) {
      console.error("Failed to find all designs:", error);
      throw error;
    }
  }
  /**
   * Store a design in localStorage
   * @param design - The design object to store
   * @returns Promise that resolves to the stored design
   */
  async storeDesign(design) {
    const designId = design.id || design.identifier;
    if (!designId) {
      throw new Error("Design ID or identifier is required for storage");
    }
    const storageKey = this.getDesignStorageKey(String(designId));
    if (this.storage.getItem(storageKey)) {
      throw new Error(`Design with ID "${designId}" already exists`);
    }
    try {
      this.storage.setItem(storageKey, this.serialize(design));
      console.log(`\u2713 Stored design: ${designId}`);
      return design;
    } catch (error) {
      console.error("Failed to store design:", error);
      throw error;
    }
  }
  /**
   * Update an existing design in localStorage
   * @param design - The updated design object
   * @returns Promise that resolves to the updated design
   */
  async updateDesign(design) {
    const designId = design.id || design.identifier;
    if (!designId) {
      throw new Error("Design ID or identifier is required for update");
    }
    const storageKey = this.getDesignStorageKey(String(designId));
    const exists = this.storage.getItem(storageKey);
    if (!exists) {
      throw new Error(`Design with ID "${designId}" does not exist`);
    }
    try {
      this.storage.setItem(storageKey, this.serialize(design));
      console.log(`\u2713 Updated design: ${designId}`);
      return design;
    } catch (error) {
      console.error("Failed to update design:", error);
      throw error;
    }
  }
  /**
   * Remove a design from localStorage
   * @param id - The design ID or identifier to remove
   * @returns Promise that resolves to true if removed, false if not found
   */
  async removeDesign(id) {
    try {
      const storageKey = this.getDesignStorageKey(id);
      const exists = this.storage.getItem(storageKey);
      if (!exists) {
        return false;
      }
      this.storage.removeItem(storageKey);
      console.log(`\u2713 Removed design: ${id}`);
      return true;
    } catch (error) {
      console.error("Failed to remove design:", error);
      throw error;
    }
  }
  /**
   * Find a mix by its UID
   * @param mixUid - The mix UID
   * @returns Promise that resolves to the mix or null if not found
   */
  async findMix(mixUid) {
    try {
      const storageKey = this.getMixStorageKey(mixUid);
      const data = this.storage.getItem(storageKey);
      if (!data) {
        return null;
      }
      return this.deserialize(data);
    } catch (error) {
      console.error("Failed to find mix:", error);
      throw error;
    }
  }
  /**
   * Find all mixes in localStorage
   * @returns Promise that resolves to an array of mixes
   */
  async findAllMixes() {
    try {
      const storageKeys = this.getAllMixStorageKeys();
      const mixes = [];
      for (const key of storageKeys) {
        try {
          const data = this.storage.getItem(key);
          if (data) mixes.push(this.deserialize(data));
        } catch (error) {
          console.error("Failed to find mix:", error);
        }
      }
      return mixes;
    } catch (error) {
      console.error("Failed to find mix:", error);
      throw error;
    }
  }
  /**
   * Store a mix in localStorage
   * @param mix - The mix object to store
   * @returns Promise that resolves to the stored mix
   */
  async storeMix(mix) {
    const mixUid = mix.mix_uid;
    if (!mixUid) {
      throw new Error("Mix UID is required for storage");
    }
    const storageKey = this.getMixStorageKey(mixUid);
    if (this.storage.getItem(storageKey)) {
      throw new Error(`Mix with ID "${mixUid}" already exists`);
    }
    try {
      this.storage.setItem(storageKey, this.serialize(mix));
      console.log(`\u2713 Stored mix: ${mixUid}`);
      return mix;
    } catch (error) {
      console.error("Failed to store mix:", error);
      throw error;
    }
  }
  /**
   * Update an existing mix in localStorage
   * @param mix - The updated mix object
   * @returns Promise that resolves to the updated mix
   */
  async updateMix(mix) {
    const mixUid = mix.mix_uid;
    if (!mixUid) {
      throw new Error("Mix UID is required for update");
    }
    const storageKey = this.getMixStorageKey(mixUid);
    const exists = this.storage.getItem(storageKey);
    if (!exists) {
      throw new Error(`Mix with ID "${mixUid}" does not exist`);
    }
    try {
      this.storage.setItem(storageKey, this.serialize(mix));
      console.log(`\u2713 Updated mix: ${mixUid}`);
      return mix;
    } catch (error) {
      console.error("Failed to update mix:", error);
      throw error;
    }
  }
  /**
   * Remove a mix from localStorage
   * @param mixUid - The mix UID to remove
   * @returns Promise that resolves to true if removed, false if not found
   */
  async removeMix(mixUid) {
    try {
      const storageKey = this.getMixStorageKey(mixUid);
      const exists = this.storage.getItem(storageKey);
      if (!exists) {
        return false;
      }
      this.storage.removeItem(storageKey);
      console.log(`\u2713 Removed mix: ${mixUid}`);
      return true;
    } catch (error) {
      console.error("Failed to remove mix:", error);
      throw error;
    }
  }
};
export {
  MyMuesliStorageService as default
};
